module.exports = "/static/assets/52797b48d511ecdd8e938684cee7638e.png";